import React from "react";
import appState from "../../service/state/app.state";
// import Input_v2_bbred from "../../UI/components/Input_v2_bbred";
import { observer } from "mobx-react-lite";
// import debugComponent from "../../service/state/debug.component";

const UserSetting = observer(() => {
  const onChangeTimeController = (e) => {
    const sec = Number(e.target.value);
    appState.setParameters("time_req_controller", sec);
    localStorage.setItem("time_req_controller", String(sec));
  };
  // const changeAutoLog = () => {
  //   if (!debugComponent.random_log) {
  //     setAutoDebugLogText("Вкл.");
  //     debugComponent.setParameters("random_log", true);
  //   } else {
  //     setAutoDebugLogText("Выкл.");
  //     debugComponent.setParameters("random_log", false);
  //   }
  // };
  // useLayoutEffect(() => {
  //   if (debugComponent.random_log === false) {
  //     setAutoDebugLogText("Выкл.");
  //   } else {
  //     setAutoDebugLogText("Вкл.");
  //   }
  // }, []);
  return (
    <ul className="list_profile mr_40">
      <li className="list_profile_name">Настройки</li>
      <li style={{ display: "flex" }}>
        {" "}
        <span className="list_profile_span_setting">
          Опрашивать контроллер через:{" "}
        </span>
        {/* <input
            className="input_v2_setting_profile"
            value={timeController}
            onChange={onChangeTimeController}
            placeholder="Телефон"
            type="number"
          /> */}
        <select
          className="select_red"
          onChange={onChangeTimeController}
          value={String(appState.time_req_controller ?? 60)}
        >
          <option value="3">3 секунды</option>
          <option value="8">8 секунд</option>
          <option value="15">15 секунд</option>
          <option value="30">30 секунд</option>
          <option value="60">1 минуту</option>
          <option value="300">5 минут</option>
          <option value="600">10 минут</option>
        </select>
      </li>
      {/* <li id="auto_logs_setting">
        <span className="list_profile_span_setting">Авто логи (отладка): </span>{" "}
        <span className="dubug_btn_auto_log" onClick={changeAutoLog}>
          {autoDebugLogText}
        </span>
        <p className="list_profile_span_setting_hover_text">
          Каждые 10 секунд будет добавляться новый лог для контроллера. Список
          логов можно отследить на страницы устройства
        </p>
      </li> */}
    </ul>
  );
});

export default UserSetting;
